import 'styled-components/macro';

import Container from '../../../../components/Container';
import KioskLiveUsageCard from './components/KioskLiveUsageCard';
import { KioskLiveUsageQuickActionsModal } from './components/KioskLiveUsageQuickActionsModal/KioskLiveUsageQuickActionsModal';
import KiosksLiveUsageContainer from './styles/KiosksLiveUsageContainer.style';
import KiosksLiveUsageFilter from './components/KiosksLiveUsageFilter';
import { KiosksLiveUsageHeader } from './styles/KiosksLiveUsage.style';
import LiveUsageNotAvailable from './components/LiveUsageNotAvailable';
import { LoadReservationOnKioskModal } from './components/LoadReservationOnKioskModal/LoadReservationOnKioskModal';
import LoadingAnimation from '../../../../components/LoadingAnimation';
import { QuickActionConfirmationModal } from './components/KioskLiveUsageQuickActionsModal/QuickActionConfirmationModal';
import React from 'react';
import { mockLiveUsage } from './__mocks__/liveUsageData';
import useGetKiosksLiveUsage from './hooks/useGetKiosksLiveUsage';
import { useKioskLiveUsageContext } from './components/contexts/KioskLiveUsageContext';
import { useLoadReservationOnKioskModalContext } from './components/contexts/LoadReservationOnKioskModalContext';
import { useQuickActionConfirmationModalContext } from './components/contexts/QuickActionConfirmationModalContext';

const KiosksLiveUsage: React.FC = () => {
  const { allKiosks } = useGetKiosksLiveUsage();
  const {
    isQuickActionsModalOpen,
    featureFlag: { isLoading: isLoadingFeatureFlag, isEnabled },
  } = useKioskLiveUsageContext();
  const { showQuickActionConfirmationModal } = useQuickActionConfirmationModalContext();
  const { isModalVisible } = useLoadReservationOnKioskModalContext();

  if (isLoadingFeatureFlag) {
    return (
      <Container>
        <LoadingAnimation />
      </Container>
    );
  }

  return (
    <Container>
      {isEnabled ? (
        <>
          <KiosksLiveUsageHeader>
            <KiosksLiveUsageFilter />
          </KiosksLiveUsageHeader>
          <Container style={KiosksLiveUsageContainer}>
            {allKiosks.map((kiosk) => (
              <KioskLiveUsageCard key={kiosk.kiosk.id} kiosk={kiosk} />
            ))}
          </Container>
          {isQuickActionsModalOpen && <KioskLiveUsageQuickActionsModal />}
          {showQuickActionConfirmationModal && <QuickActionConfirmationModal />}
          {isModalVisible && <LoadReservationOnKioskModal />}
        </>
      ) : (
        <Container
          style={{
            ...KiosksLiveUsageContainer,
            position: 'relative',
          }}
        >
          {mockLiveUsage.map((kiosk) => (
            <KioskLiveUsageCard key={kiosk.kiosk.id} kiosk={kiosk} />
          ))}
          <LiveUsageNotAvailable />
        </Container>
      )}
    </Container>
  );
};

export default KiosksLiveUsage;
